// Browser-side Supabase client — ONE instance, created once, reused everywhere.
// supabase-js attaches the JWT automatically on every request from this instance.
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Single shared instance with session persistence enabled.
// persistSession: true — session is stored and survives page reloads.
// autoRefreshToken: true — refresh token is used automatically before expiry.
// storageKey: uses localStorage by default (persists across browser restarts).
// Never logs the user out while a valid refresh token exists.
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  },
});

export function getSupabase() {
  return supabase;
}

// Keep for backward-compat imports — no-op now that we use a true singleton.
export function resetSupabaseClient() {
  // intentional no-op: session is managed by the singleton
}
